<!-- Note: padding-bottom + margin-bottom to equal 80px. This is to keep any action button above the recaptcha/chat badges in mobile view -->
<div 
  class="bl-padding-top--24 bl-padding-bottom--40 bl-margin-bottom--40 bl-padding-x--16 bl-padding-x-sm--24"
  [attr.data-automation-id]="page.automationId">
  <div class="bl-max-width--layout bl-margin-x--auto">
    <div class="bl-max-width--tablet-width bl-margin-x--auto">
      <ng-content select="[page-aside]"></ng-content>
      <ng-content select="[page-body]"></ng-content>
    </div>
  </div>
</div>